module.exports = __webpack_public_path__ + "img/mp4.634046c1.png";